<bit-base-card
  class="tw-z-[2] tw-relative !tw-rounded-[16px] tw-mb-4 sm:tw-mb-5 tw-mx-auto tw-w-full tw-bg-transparent tw-border-none tw-shadow-none !tw-p-0 sm:tw-bg-[var(--vk-card)] sm:tw-border sm:tw-border-solid sm:tw-border-[var(--vk-line)] sm:[box-shadow:0_1px_2px_rgb(18_18_22_/_0.04),0_12px_28px_-12px_rgb(18_18_22_/_0.09)] sm:!tw-p-7"
>
  <ng-content></ng-content>
</bit-base-card>
